import { render, staticRenderFns } from "./Sdk.vue?vue&type=template&id=b07e867c&scoped=true"
import script from "./Sdk.vue?vue&type=script&lang=js"
export * from "./Sdk.vue?vue&type=script&lang=js"
import style0 from "./Sdk.vue?vue&type=style&index=0&id=b07e867c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e867c",
  null
  
)

export default component.exports